import React, { useState } from 'react';
import { toast } from 'react-toastify';
import { Button, Col, Form, Input, Label, Modal, ModalBody, ModalHeader, Row, Spinner } from 'reactstrap';
import { addClientAPI } from '../../apiConfig/apiCall';
import { useDispatch } from 'react-redux';
import { getClients } from '../../slices/ManageClient/thunk';

const AddClientModal = ({ addClentModalOpen, setAddClentModalOpen, handleAddClientModal }) => {
    const dispatch = useDispatch();

    // Add Client Logic
    const [formData, setFormData] = useState({
        companyName: '',
        email: '',
        contactNumber: '',
        companyUrl: '',
    });

    const [submittingForm, setSubmittingForm] = useState(false); // submittingForm state

    const handleInputChange = (e) => {
        const { id, value } = e.target;
        setFormData({
            ...formData,
            [id]: value
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (submittingForm) return; // Prevent duplicate submissions

        try {
            const { companyName, email, contactNumber, companyUrl } = formData;

            if (!companyName) {
                toast.error('Company Name is required');
                return;
            } else if (companyName.length > 100) {
                toast.error('Company Name cannot exceed 100 characters');
                return;
            }

            if (!email) {
                toast.error('Email is required');
                return;
            } else if (email.length > 50) {
                toast.error('Email cannot exceed 50 characters');
                return;
            } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
                toast.error('Please enter a valid email address');
                return;
            }

            if (!contactNumber) {
                toast.error('Contact Number is required');
                return;
            } else if (!/^\d{8,15}$/.test(contactNumber)) {
                toast.error('Contact Number must be between 8 and 15 digits');
                return;
            }

            if (!companyUrl) {
                toast.error('Company URL is required');
                return;
            } else if (companyUrl.length > 50) {
                toast.error('Company URL cannot exceed 50 characters');
                return;
            } else if (!/^(https?:\/\/)([\w-]+(\.[\w-]+)+)(\/[\w-]*)*$/i.test(companyUrl)) {
                toast.error('Please enter a valid URL starting with http:// or https://');
                return;
            }

            const clientData = { companyName, email, contactNumber, companyUrl };

            setSubmittingForm(true); // Set submittingForm to true before making the API call
            const apiResponse = await addClientAPI(clientData);

            if (apiResponse.status === 201) {
                toast.success(apiResponse.data);
                setAddClentModalOpen(false);
                dispatch(getClients());
            } else if (apiResponse.status === 400) {
                toast.error(apiResponse.data);
            } else {
                toast.error(apiResponse.data);
            }
        } catch (error) {
            console.error('Error sending data:', error);
            toast.error('An error occurred while adding the client');
        } finally {
            setSubmittingForm(false);
        }
    };

    return (
        <Modal isOpen={addClentModalOpen} toggle={handleAddClientModal} size="lg">
            <ModalHeader toggle={handleAddClientModal}>Add Client</ModalHeader>
            <ModalBody>
                <Row>
                    <Col lg={12}>
                        <Form>
                            <Row className="gy-4">
                                <Col lg={6}>
                                    <div>
                                        <Label htmlFor="companyName" className="form-label">Company Name</Label>
                                        <Input
                                            type="text"
                                            className="form-control"
                                            id="companyName"
                                            value={formData.companyName}
                                            onChange={handleInputChange}
                                            disabled={submittingForm}
                                        />
                                    </div>
                                </Col>
                                <Col lg={6}>
                                    <div>
                                        <Label htmlFor="email" className="form-label">Email</Label>
                                        <Input
                                            type="email"
                                            className="form-control"
                                            id="email"
                                            value={formData.email}
                                            onChange={handleInputChange}
                                            disabled={submittingForm}
                                        />
                                    </div>
                                </Col>
                                <Col lg={6}>
                                    <div>
                                        <Label htmlFor="contactNumber" className="form-label">Contact Number</Label>
                                        <Input
                                            type="text"
                                            className="form-control"
                                            id="contactNumber"
                                            value={formData.contactNumber}
                                            onChange={handleInputChange}
                                            disabled={submittingForm}
                                        />
                                    </div>
                                </Col>
                                <Col lg={6}>
                                    <div>
                                        <Label htmlFor="companyUrl" className="form-label">Company URL</Label>
                                        <Input
                                            type="url"
                                            className="form-control"
                                            id="companyUrl"
                                            value={formData.companyUrl}
                                            onChange={handleInputChange}
                                            disabled={submittingForm}
                                        />
                                    </div>
                                </Col>
                                <Col lg={12}>
                                    {
                                        submittingForm ? <Button color = "primary" className="me-2"  type='button' disabled>
                                            <Spinner size="sm"> Loading... </Spinner> </Button> : <Button color="primary" type="submit" className="me-2" disabled={submittingForm} onClick={handleSubmit}> Add  </Button>
                                    }
                                <Button color="secondary" type="reset" disabled={submittingForm} onClick={() => setFormData({ companyName: '', email: '', contactNumber: '', companyUrl: '' })} > Reset </Button>
                            </Col>
                        </Row>
                    </Form>
                </Col>
            </Row>
        </ModalBody>
        </Modal >
    );
};

export default AddClientModal;